<template>
  <section class="mailbox-wrapper">
    <div v-if="!composeEmailLoading">
    <div class="header-move-email">
      <div class="moveActions">
        <div class="move-email-lhs" @click="hideMoveEmailPopUp"><span> < Back</span></div>
        <div class="move-email-title">Email</div>
        <div class="move-email-rhs" @click="hideMoveEmailPopUp"><span> Cancel</span></div>
      </div>
      <div class="info-move-content">
        <p>Move this message to a new mailbox:</p>
      </div>
      <div class="email-tobe-moved">
        <div class="mv-email-sender"> <span> {{ mailDetails.from[0].name }} </span></div>
        <div class="mv-email-subject"> <span> {{ mailDetails.subject }} </span></div>
      </div>
    </div>

    <div class="mailbox-container">
      <div>
        <!-- The personalised folders -->
        <a href="javascript:void(0);" class="show-personal-folder" @click="toggleFolders">
          <object
            class="search-icon chat"
            :data="personalIcon"
            type="image/png"
          ></object>
          <span v-if="!showFolders"> Show</span>
          <span v-else>Hide</span> personal folders
        </a>
        <ul v-if="showFolders" class="sub-folder-container">
          <li v-for="(folder, index) in emailFolderList" :class="{'no-subfolder': folder.folders.length === 0}" :key="index">
            <span  class="d-block plain">
              <a href="javascript:void(0);" v-show="folder.folders.length > 0" @click="collapse(folder)">
                <object
                  class="search-icon icon-plus-minus"
                  :data="(folder.expandFlag === 0) ? iconPlus : iconMinus"
                  type="image/png"
                ></object>
              </a>
              <span @click="moveTo(folder.folderId, folder.folderName)">
                <object
                  class="search-icon icon-plus-minus"
                  :data="folderIcon"
                  type="image/png"
                ></object>
                {{ folder.folderName }}
              </span>
            </span>
            <ul v-if="(folder.folders.length > 0) && (folder.expandFlag === 1)">
              <li v-for="(folder1, index1) in folder.folders" :class="{'no-subfolder': folder1.folders.length === 0}" :key="index1">
                <span class="d-block plain">
                  <a href="javascript:void(0);" v-show="folder1.folders.length > 0" @click="collapse(folder1)">
                    <object
                      class="search-icon icon-plus-minus"
                      :data="(folder1.expandFlag === 0) ? iconPlus : iconMinus"
                      type="image/png"
                    ></object>
                  </a>
                  <span @click="moveTo(folder1.folderId, folder1.folderName)">
                    <object
                      class="search-icon icon-plus-minus"
                      :data="folderIcon"
                      type="image/png"
                    ></object>
                    {{ folder1.folderName }}
                  </span>
                </span>
                <ul v-if="(folder1.folders.length > 0) && (folder1.expandFlag === 1)">
                  <li
                    v-for="(folder2, index2) in folder1.folders"
                    :key="index2"
                    :class="{'no-subfolder': folder2.folders.length === 0}"
                  >
                    <span class="d-block plain">
                      <a href="javascript:void(0);" v-show="folder2.folders.length > 0" @click="collapse(folder2)">
                        <object
                          class="search-icon icon-plus-minus"
                          :data="(folder2.expandFlag === 0) ? iconPlus : iconMinus"
                          type="image/png"
                        ></object>
                      </a>
                      <span @click="moveTo(folder2.folderId, folder2.folderName)" >
                        <object
                          class="search-icon icon-plus-minus"
                          :data="folderIcon"
                          type="image/png"
                        ></object>
                        {{ folder2.folderName }}
                      </span>
                    </span>
                    <ul v-if="(folder2.folders.length > 0) && (folder2.expandFlag === 1)" class="sub-folder-content">
                      <li
                        v-for="(folder3, index3) in folder2.folders"
                        :key="index3"
                      >
                        <span class="d-block plain">
                          <span @click="moveTo(folder3.folderId, folder3.folderName)">
                            <object
                              class="search-icon icon-plus-minus"
                              :data="folderIcon"
                              type="image/png"
                            ></object>
                            {{ folder3.folderName }}
                          </span>
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    </div>
    <transition name="fade">
      <div class="loader-container" v-if="composeEmailLoading">
        <loader-vue />
      </div>
    </transition>
  </section>
</template>

<script>
  import { nameMixin } from "../../../mixins/nameMixin";
  import { mailFolder } from "../../../mixins/mailFolder";
  import { mapMutations, mapGetters } from "vuex";
  import Vue from "vue";

  export default {
    name: "MailBoxesSection",
    mixins: [nameMixin, mailFolder],
    props: {
      mailDetails: Object
    },
    data() {
      return {
        emptyStarIcon: require("../../../assets/img/m_favorites-empty.png"),
        filledStarIcon: require("../../../assets/img/m_favorites.png"),
        showFolders: true,
        inboxIcon: require("../../../assets/img/icon-email-inbox.png"),
        unreadIcon: require("../../../assets/img/icon-email-unread.png"),
        favoritesIcon: require("../../../assets/img/icon-email-favourites.png"),
        recentsIcon: require("../../../assets/img/icon-email-recent.png"),
        sentIcon: require("../../../assets/img/icon-email-sent.png"),
        draftsIcon: require("../../../assets/img/icon-email-drafts.png"),
        trashIcon: require("../../../assets/img/icon-email-trash.png"),
        personalIcon: require("../../../assets/img/icon-show-per-folders.png"),
        iconMinus: require("../../../assets/img/icon-collapse-folder.png"),
        iconPlus: require("../../../assets/img/icon-expand-folder.png"),
        folderIcon: require("../../../assets/img/icon-for-folder.png"),
        emailFolderList: []
      };
    },
    computed: {
      ...mapGetters("portalemail", {
        composeEmailLoading: "getComposeEmailLoading",
        emailFolder: "getEmailFolder",
        boxCount: "getBoxCount",
        selectedUserId: "getSelectedUserId"
      }),
    },
    methods: {
      ...mapMutations("portalemail", {
        setComposeEmailLoading: "setComposeEmailLoading",
        resetEmails: "resetEmails",
        setBoxCount: "setBoxCount"
      }),

      /**
       * Function to collapse/expand the personalised folders
       */
      collapse(array) {
        let expandFlag = array.expandFlag === 0 ? 1 : 0;
        if(0 === expandFlag) {
          this.setExpandable(array.folders, expandFlag);
        }
        array.expandFlag = expandFlag;
      },

      /**
       * Function to move a mail to another folder
       */
      async moveTo(folderId, folderName) {
        this.setComposeEmailLoading(true);
        let moveEmailRes = await this.$store.dispatch(
          "makeAuthRequest",
          {
            url: "portalemail/moveemail",
            method: "PUT",
            chat: true,
            data: {
              folderId: folderId,
              selectedMailboxIDs: [parseInt(this.$route.params.id)],
              selectedSubscriberId: this.$store.getters.getSelectedProviderID,
              appUserId: this.selectedUserId
            }
          },
          {
            root: true
          }
        );
        this.setComposeEmailLoading(false);

        if(moveEmailRes.error) {
          this.$store.dispatch("globalMessagePopup", moveEmailRes.error);
        } else {
          Vue.nextTick(() => {
            this.resetEmails({boxType: 'all', folderId: 0});
            this.setBoxCount({
              key: 'needLoad',
              value: true
            });
            this.$parent.toggleMoveClick();
            this.$parent.mailDetail.folder_id = folderId;
          });
          this.$store.dispatch("globalMessagePopup", "Your message was moved to " + folderName);
        }
      },

      /**
       * Function to show/hide personal folder
       */
      toggleFolders() {
        this.showFolders = !this.showFolders;
      },

      hideMoveEmailPopUp() {
        this.$emit("hideMoveEmail");
      }
    },

    async created() {
      if(this.emailFolder) {
        this.emailFolderList = this.setExpandable(JSON.parse(JSON.stringify(this.emailFolder)), 1);
      } else {
        this.emailFolderList = [];
      }
    }
  };
</script>

<style scoped>
  .header-move-email{
    clear: both;
    padding:10px;
  }
  .moveActions{
    clear:both;
    margin-bottom:10px;

  }

  .move-email-lhs{
    float:left;
    width:55px;
    color:#d26d13;
  }
  .move-email-lhs span {
    cursor: pointer;
  }
  .move-email-title{
    margin:0 auto 10px;
    text-align:center;
    width:calc(100% - 110px);
    float:left;
    font-weight: 300;
    font-size: 20px;
    color: #000;
  }
  a.show-personal-folder span{
  padding-left:5px;
}
  .move-email-rhs{
    float:right;
    width:55px;
    text-align: right;
    color:#d26d13;

  }
  .move-email-rhs span {
    cursor: pointer;
  }
  .info-move-content{
    margin:0 auto 15px;
    text-align:center;
    clear:both;
  }
  .info-move-content p{
    margin:0 auto;
  }
  .email-tobe-moved{
    max-width:320px;
    margin:0 auto;
    background:#fff;
    border:1px solid #ccc;
    padding:15px;
    font-size:14px;
  }
  .mv-email-sender{
    font-size:20px;
    margin:0 0 5px 0;
  }
  .mv-email-subject{
    margin-bottom:15px;
  }
  .mv-email-no-of-messages{
    font-size:13px;
  }

  .folderTreeImg{
    vertical-align:middle;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
    height: 16px;
    width: 16px;
    padding: 0;
  }
  .sub-folder-container {
    margin-bottom: 110px !important;
  }
  .moveEmailNonLink{
    width: 98%;
    margin: 0 auto;
  }
  .mailbox-wrapper{
    margin: 0;
    z-index: 9999999;
    top: 50px;
    height: 100%;
    position: fixed;
    background-color: #f2f2f2;
    width: 100%;
    overflow: auto;
  }
  section ul {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin-top: 0px;
  }

  .reduce-header {
    margin-top: 93px !important;
  }

  section ul li {
    list-style: none;
    padding: 15px;
    display: flex;
    align-items: center;
    font-size:16px;
  }

  .img-star {
    width: 1.3rem;
    height: 1.3rem;
    margin-right: 1rem;
  }

  section ul li.online {
    border-right: 5px solid lightgreen;
  }

  section ul li:hover {
    /* background-color: rgba(210, 109, 19, 0.1); */
    cursor: pointer;
  }
  .mailbox-content{
    margin-bottom:12px;
  }
  .mailbox-content li{
    width:100%;
    padding:15px 0!important;
    margin:0 auto;
    border-bottom:1px solid #f2f2f2;
    line-height: 24px;
  }
  .mailbox-content li a{
    width:98%;
    margin:0 auto;
  }
  .mailbox-content li span.mail-count{
    float:right;
    text-align:right;
    position:relative;
    top:10px;
  }

  section ul li div.mailbox-content.no-star {
    max-width: 100%;
  }

  section ul li div.mailbox-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    max-width: 90%;
  }

  section ul li div.mailbox-content div.title {
    display: flex;
    margin-bottom: 3px;
  }

  section ul li div.mailbox-content div.content {
    display: flex;
  }

  section ul li div.mailbox-content div.content span.message {
    color: gray;
    font-size: 13px;
    flex-grow: 1;
    max-width: calc(100% - 20px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 18px;
  }

  section ul li div.mailbox-content div.content span.new-messages {
    font-size: 10px;
    background-color: rgb(210, 109, 19);
    width: 20px;
    height: 20px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
  }

  section ul li div.mailbox-content div.title span.name {
    flex-grow: 1;
    font-weight: lighter;
    color: #383838;
  }

  section ul li div.mailbox-content div.title span.time {
    font-size: 13px;
    font-weight: lighter;
    color: gray;
  }

  .swipe-enter-active {
    animation: swipeIn 0.4s ease-in-out;
  }

  .swipe-leave-active {
    animation: swipeOut 0.4s ease-in-out;
  }

  .swipe-move {
    transition: all 0.4s ease-in-out;
  }

  .loader-container-small {
    padding: 1px 7px 0px 0px;
    margin-right: 0.7rem;
  }

  .loader-small {
    float: left;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #d26d13;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    animation: spin 0.5s linear infinite;
  }
  a.show-personal-folder{
    margin-left:16px;
  }
  .sub-folder-container{
    margin:0;
  }
  .sub-folder-container li{
    align-items:start;
    padding:10px 5px 5px 40px;
    width:96%;
    display:block;
  }
  .sub-folder-container > li{
    border-bottom:1px solid #f2f2f2;
    line-height: 24px;
  }
  .sub-folder-container li > a{
    font-size:15px;
  }
  .sub-folder-container li ul{
    margin:0 10px 0 27px!important;
  }
  .sub-folder-container li ul li{
    padding:5px 5px;
  }
  .sub-folder-container li .sub-folder-content{
    margin:5px 0 0 0;
  }
  .sub-folder-container li .sub-folder-content li{
    padding:0px;
    background:none!important;
  }
  .sub-folder-container li .sub-folder-content li a{
    font-size:13px;
    color:#d26d13;
    display:block;
    margin:5px 0;
    line-height: 24px;
  }
  .sub-folder-container li .sub-folder-content li:last-child{
    border-bottom:none;
  }
  .sub-folder-container li a .icon-plus-minus{
    width:18px;
      padding-right: 3px;

  }
  .no-subfolder{
    position:relative;
    left:16px;
  }
.mailbox-container{
  max-height:calc(100% - 170px);
  overflow-y:auto;
  overflow-x:hidden;

}
  @keyframes swipeIn {
    from {
      opacity: 0;
      transform: translateX(-100px);
    }

    50% {
      opacity: 0.5;
      transform: translateX(-50px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes swipeOut {
    from {
      opacity: 1;
      transform: translateX(0);
    }

    50% {
      opacity: 0.5;
      transform: translateX(-50px);
    }

    to {
      opacity: 0;
      transform: translateX(-100px);
    }
  }
  @media screen and (max-width:767px){
    .mailbox-content li{
      width:97%;
      padding:15px 6px!important;
    }
    a.show-personal-folder{
      margin-left:10px
    }
  }
</style>
